import React, { useState } from 'react'
import AdminEirTassi from './AdminEirTassi'
import AdminEirZone from './AdminEirZone'
import AdminEirParametri from './AdminEirParametri'
import AdminLloydVolanteTassi from './AdminLloydVolanteTassi'
import AdminLloydPlusTassi from './AdminLloydPlusTassi'
import AdminCoveaTassi from './AdminCoveaTassi'
import AdminCoveaZone from './AdminCoveaZone'
import AdminQuixaTassi from './AdminQuixaTassi'
import AdminQuixaZone from './AdminQuixaZone'
import AdminSogessurTassi from './AdminSogessurTassi'
import AdminSogessurZone from './AdminSogessurZone'

// Catalogo compagnie con relative sezioni editabili
const COMPAGNIE = [
  {
    codice: 'EIR',
    nome: 'EIR',
    sezioni: [
      { key: 'tassi',     label: 'Tassi',                 Component: AdminEirTassi },
      { key: 'zone',      label: 'Zone province',         Component: AdminEirZone },
      { key: 'durata',    label: 'Parametri tariffa',     Component: AdminEirParametri },
    ],
  },
  {
    codice: 'LLOYD_VOLANTE',
    nome: "Lloyd's Volante",
    sezioni: [
      { key: 'tassi', label: 'Tassi', Component: AdminLloydVolanteTassi },
    ],
  },
  {
    codice: 'LLOYD_PLUS',
    nome: "Lloyd's Plus",
    sezioni: [
      { key: 'tassi', label: 'Tassi', Component: AdminLloydPlusTassi },
    ],
  },
  {
    codice: 'COVEA',
    nome: 'Covea (annuale + poliennale)',
    sezioni: [
      { key: 'tassi', label: 'Tassi',         Component: AdminCoveaTassi },
      { key: 'zone',  label: 'Zone province', Component: AdminCoveaZone },
    ],
  },
  {
    codice: 'QUIXA',
    nome: 'Quixa',
    sezioni: [
      { key: 'tassi', label: 'Tassi',         Component: AdminQuixaTassi },
      { key: 'zone',  label: 'Zone province', Component: AdminQuixaZone },
    ],
  },
  {
    codice: 'SOGESSUR',
    nome: 'Sogessur',
    sezioni: [
      { key: 'tassi', label: 'Tassi',         Component: AdminSogessurTassi },
      { key: 'zone',  label: 'Zone province', Component: AdminSogessurZone },
    ],
  },
]

export default function AdminTariffe() {
  const [codice, setCodice] = useState('EIR')
  const [sezKey, setSezKey] = useState('tassi')

  const comp = COMPAGNIE.find(c => c.codice === codice)
  const sez = comp.sezioni.find(s => s.key === sezKey) || comp.sezioni[0]
  const Comp = sez.Component

  function changeCompagnia(nuovoCodice) {
    setCodice(nuovoCodice)
    // Resetta sezione alla prima disponibile della nuova compagnia
    const nuovaComp = COMPAGNIE.find(c => c.codice === nuovoCodice)
    setSezKey(nuovaComp.sezioni[0].key)
  }

  return (
    <div>
      <div className="page-header">
        <h1>Tariffe</h1>
        <p>Seleziona la compagnia e la sezione (tassi, zone, ecc.) da modificare.</p>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div>
            <label className="text-small" style={{ display: 'block', marginBottom: 4 }}>Compagnia</label>
            <select
              value={codice}
              onChange={e => changeCompagnia(e.target.value)}
              style={{ minWidth: 220 }}
            >
              {COMPAGNIE.map(c => (
                <option key={c.codice} value={c.codice}>{c.nome}</option>
              ))}
            </select>
          </div>

          {comp.sezioni.length > 1 && (
            <div>
              <label className="text-small" style={{ display: 'block', marginBottom: 4 }}>Sezione</label>
              <div className="tabs" style={{ marginBottom: 0 }}>
                {comp.sezioni.map(s => (
                  <div
                    key={s.key}
                    className={`tab ${sez.key === s.key ? 'active' : ''}`}
                    onClick={() => setSezKey(s.key)}
                  >
                    {s.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* key forza re-mount quando cambia compagnia/sezione, così lo stato locale di edit si resetta */}
      <Comp key={`${codice}-${sez.key}`} />
    </div>
  )
}
